import useResizeObserver from '@react-hook/resize-observer';
import { useSetAtom } from 'jotai';
import React from 'react';

import { pageWrapperSizeAtom } from '../../../../store/index.atom';
import useSwipe from '../../../../hooks/useSwipe';

import * as Styled from './index.styles';

export interface Props {
  totalPage?: number;
  isNextPageButtonDisabled?: boolean;
  updateNextThumbnails?: (page: number) => void;
  updatePrevThumbnails?: (page: number) => void;
}

const MobilePageWrapper = ({
  totalPage,
  isNextPageButtonDisabled,
  updateNextThumbnails,
  updatePrevThumbnails,
  children,
}: React.PropsWithChildren<Props>) => {
  const setPageWrapperSize = useSetAtom(pageWrapperSizeAtom);

  const wrapperRef = React.useRef<HTMLDivElement>(null);
  useResizeObserver(wrapperRef, ({ contentRect: { width, height } }) =>
    setPageWrapperSize({
      width,
      height,
    }),
  );

  const { handleTouchEnd, handleTouchMove, handleTouchStart } = useSwipe({
    totalPage,
    isNextSwipeDisabled: isNextPageButtonDisabled,
    updateNextThumbnails,
    updatePrevThumbnails,
  });

  return (
    <Styled.Wrapper
      ref={wrapperRef}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
      onContextMenu={(e) => e.preventDefault()}
      onDragStart={(e) => e.preventDefault()}
    >
      {children}
    </Styled.Wrapper>
  );
};

export default MobilePageWrapper;
